// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"dc40a849","614":"8a2b3e29"}[chunkId] + ".chunk.css";
};